import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "../../../Stores/AuthStore";

// Rôles autorisés pour gestion-sav
const ALLOWED_ROLES = ['ROLE_ADMIN', 'ROLE_SUPER_ADMIN', 'ROLE_SUPERVISOR', 'ROLE_COMMERCIAL'];

const hasAllowedRole = (roles: string[] | undefined): boolean => {
  return roles?.some(role => ALLOWED_ROLES.includes(role)) ?? false;
};

export default function RequireAuth({ children }: { children: JSX.Element }) {
  const auth = useAuthStore();
  const location = useLocation();

  if (location.hash.startsWith("#login_with_access_token=")) {
    const access_token = location.hash.substring("#login_with_access_token=".length);
    return <Navigate to="/login" state={{ from: location, access_token }} replace />
  }

  if (!auth.user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Vérifier si l'utilisateur est actif
  if (!auth.user.isActive) {
    auth.logout();
    return <Navigate to="/login" state={{ error: "Votre compte a été désactivé. Veuillez contacter un administrateur." }} replace />;
  }

  // Vérifier si l'utilisateur a un rôle autorisé
  if (!hasAllowedRole(auth.user.roles)) {
    auth.logout();
    return <Navigate to="/login" state={{ error: "Vous n'avez pas les droits d'accès à cette application." }} replace />;
  }

  return children;
}
